export default __webpack_public_path__ + "10a81e9c60ac9af7319e5780e7c58ed3.otf";